export default "__VITE_ASSET__DFAhf3GR__"